import { Box, Grid } from "@material-ui/core";

import FormFieldAttachmentBase, {
  FieldAttachment,
} from "../../../../forms/FormFieldAttachmentBase";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationAttachmentForm, { ReRegistrationAttachmentFormItem } from "../../../../forms/recadastramento/ReRegistrationAttachmentForm";
import TmpAttachmentCustom from "../../../../components/tempo/TmpAttachmentCustom/TmpAttachmentCustom";
import TmpTypographyCustom from "../../../../components/tempo/TmpTypographyCustom/TmpTypographyCustom";
import React from "react";

interface IReRegistrationAttachmentDataComponentProps {
  ReRegistrationAttachmentForm: ReRegistrationAttachmentForm;
  onInputChange: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void;
  onDeleteFile: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void;
  onInputChangeDynamic: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: ReRegistrationAttachmentFormItem) => void;
  onDeleteFileDynamic: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: ReRegistrationAttachmentFormItem) => void;
}

export default function ReRegistrationAttachmentDataComponent(props: IReRegistrationAttachmentDataComponentProps) {

  return (
    <div>

      <Grid container >
        {props.ReRegistrationAttachmentForm.FilesPendingInclusion === undefined || props.ReRegistrationAttachmentForm.FilesPendingInclusion.length === 0 ?
          <Grid item xs={12}>
            <div style={{ display: "flex" }}>
              <div >
                <TmpTypographyCustom component="paragraph" size="small" variant="h4" id="mensagem-1">
                  Todos os documentos foram entregues.
                </TmpTypographyCustom>
              </div>
            </div>
          </Grid>
          : null
        }
      </Grid>

      {/* Início - Lista de arquivos obrigatórios */}

      {props.ReRegistrationAttachmentForm.ExistMandatoryFiles === true && props.ReRegistrationAttachmentForm.FilesPendingInclusion !== undefined && props.ReRegistrationAttachmentForm.FilesPendingInclusion.length > 0 ?
        <React.Fragment>
          <Box marginBottom={2}>
            <TmpTypographyCustom component="paragraph" id="texto-documentos-faltantes" size="small" variant="h6">
              Obrigatórios
            </TmpTypographyCustom>
          </Box>
          <Grid container >
            {props.ReRegistrationAttachmentForm.FilesPendingInclusion !== undefined && props.ReRegistrationAttachmentForm.FilesPendingInclusion.map((attachment, index) => (
              attachment.FileField !== undefined && attachment.FileField.Mandatory ?
                <Grid item xs={6} key={`${index}_dynamic_file`}>
                  <TmpAttachmentCustom
                    label={attachment.Description}
                    name={`name_${attachment.Id}_${index}`}
                    id={`id_${attachment.Id}_${index}`}
                    limitedFiles={3}
                    typeFiles={"image/*, .pdf"}
                    linkFileName={attachment.LinkFileName}
                    linkFile={attachment.LinkFile}
                    values={attachment.FileField?.Values}
                    mandatory={attachment.FileField?.Mandatory}
                    error={attachment.FileField?.HasError()}
                    helperText={attachment.FileField?.Error || attachment.HelperText}
                    helperIcon={attachment.HelperIcon}
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFileDynamic("AttachmentDynamic", props.ReRegistrationAttachmentForm, fieldAttachment, attachment);
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChangeDynamic("AttachmentDynamic", props.ReRegistrationAttachmentForm, fieldAttachment, attachment);
                    }}
                  />
                </Grid>
                : null
            ))
            }
          </Grid>
        </React.Fragment>
        : null
      }
      {/* Início - Lista de arquivos obrigatórios */}


      {/* Início - Lista de arquivos opicionais */}
      {props.ReRegistrationAttachmentForm.ExistOptionalFiles === true ?
        <React.Fragment>
          <Box marginBottom={2}>
            <TmpTypographyCustom component="paragraph" id="texto-documentos-opcionais" size="small" variant="h6">
              Opcionais
            </TmpTypographyCustom>
          </Box>
          <Grid container >

            {props.ReRegistrationAttachmentForm.FilesPendingInclusion !== undefined && props.ReRegistrationAttachmentForm.FilesPendingInclusion.map((attachment, index) => (
              attachment.FileField !== undefined && !attachment.FileField.Mandatory ?
                <Grid item xs={6} key={`${index}_dynamic_file`}>

                
                  <TmpAttachmentCustom
                    label={attachment.Description}
                    name={`name_${attachment.Id}_${index}`}
                    id={`id_${attachment.Id}_${index}`}
                    linkFileName={attachment.LinkFileName}
                    linkFile={attachment.LinkFile}
                    limitedFiles={3}
                    typeFiles={"image/*, .pdf"}
                    values={attachment.FileField?.Values}
                    mandatory={attachment.FileField?.Mandatory}
                    error={attachment.FileField?.HasError()}
                    helperText={attachment.FileField?.Error || attachment.HelperText}
                    helperIcon={attachment.HelperIcon}
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFileDynamic("AttachmentDynamic", props.ReRegistrationAttachmentForm, fieldAttachment, attachment);
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChangeDynamic("AttachmentDynamic", props.ReRegistrationAttachmentForm, fieldAttachment, attachment);
                    }}
                  />
                </Grid>
                : null
            ))}
          </Grid>
        </React.Fragment>
        : null}
      {/* Início - Lista de arquivos opicionais */}

    </div >
  );
}
